import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import SignIn from "./pages/SignIn/SignIn";
import Profile from "./pages/Profile/Profile";
import ProtectedAppShell from "./routes/ProtectedAppShell";
import { AuthBootstrapProvider } from "./context/AuthBootstrapContext";
import { NotificationsProvider } from "./context/NotificationsContext";
import Events from "./pages/Events";
import './App.css'
import SettingsPage from "./pages/settings/SettingsPage";
import OnboardingFlow from "./pages/OnboardingFlow";
import FikaPage from "./pages/Fika";
import FeaturedPage from "./pages/Featured";
import StudioPage from "./pages/Studio";
import AdminPortal from "./pages/Admin/AdminPortal";
import AdminCycles from "./pages/Admin/AdminCycles";
import RedeemPage from "./pages/Redeem";
export default function App() {
  return (
    <Router>
      <AuthBootstrapProvider>
        <NotificationsProvider>
        <Routes>
          <Route path="/" element={<SignIn />} />
          <Route path="/sign-in" element={<SignIn />} />
          <Route path="/verify" element={<SignIn />} />
          <Route path="/admin-fika-8017" element={<AdminPortal />} />
          <Route path="/admin-fika-8017/cycles" element={<AdminCycles />} />
          <Route element={<ProtectedAppShell />}>
            <Route path="/onboarding" element={<OnboardingFlow />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/profile/:personId" element={<Profile />} />
            <Route path="/events" element={<Events />} />
            <Route path="/fikas" element={<FikaPage />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/featured" element={<FeaturedPage />} />
            <Route path="/studio" element={<StudioPage />} />
            <Route path="/redeem/:cafeUuid" element={<RedeemPage />} />
          </Route>
        </Routes>
        </NotificationsProvider>
      </AuthBootstrapProvider>

      <Analytics />
    </Router>
  );
}